import { render, staticRenderFns } from "./ImageGallerySpecialDropSlot.vue?vue&type=template&id=0ed451c6&scoped=true&"
import script from "./ImageGallerySpecialDropSlot.vue?vue&type=script&lang=ts&"
export * from "./ImageGallerySpecialDropSlot.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGallerySpecialDropSlot.vue?vue&type=style&index=0&id=0ed451c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed451c6",
  null
  
)

export default component.exports